export const cutAddress = (address) => {
    return `${address.slice(0,6)}...${address.slice(-4)}`;
}

export const cortador = (title) => {
    return title.length > 30 ? `${title.slice(0,50)}...` : title;
}

export const URI = "https://backend-store-blockchain.vercel.app/";

export const URL_INFURA = "https://ipfs.infura.io/ipfs/";
export const SHIPPING = 9.95;

export const DAI_TOKEN = "0x732862d2c03347f511987199FCEBaEe8A83B0dfa";
export const USDT_TOKEN = "0xE01DFa7E09BdB944624333Ea5db0DD56cbfadB8f";
export const BUSD_TOKEN = "0x50328933140fA336a248C38C7b7f4a4aF286a628";
export const STORE_TOKEN = "0x896F79cF6dbF404aCE3932f2CC5B4A9587c557B1";
export const STORE_REWARDS = "0x8bB0C85b6E48aF54F0aF722C2D952764562B2678";